import React from 'react';
import Conditional from '../../../common/conditional';
import CustomSection from '../../custom-general/custom-section';
import Image from '../../../blocks/report-image/image';

import classNames from './style.module.scss';

import { PDFImageProps } from '../../../../utils/models';


interface AnomalyLocationProps {
	lineNumber?: string;
	locationImages: PDFImageProps[];
}

const AnomalyLocation: React.FC<AnomalyLocationProps> = ({
	lineNumber,
	locationImages,
}) => {
	return (
		<>
			{locationImages.map((locationImage) => (
				<CustomSection
					key={locationImage.refNo}
					sectionSubtitle="Anomaly Location"
					sectionTitle="Inspection Findings"
					identifier={lineNumber}
				>
					<Conditional isVisible={!!lineNumber}>
						<div className={classNames.anomalyLocationHeader}>
							Line Number: <span className="mx-2">{lineNumber}</span>
						</div>
					</Conditional>
						<div className={classNames.anomalyLocation}>
							<Image src={locationImage.src} alt={locationImage.caption} />
							<Conditional isVisible={false}>
								<div className={classNames.anomalyLocationCaption}>{locationImage.caption}</div>
							</Conditional>
						</div>
				</CustomSection>
			))}
		</>
	);
};

export default AnomalyLocation;
